// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__3Ac_l","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__-OdFw"};